export const HOME_STEP = {
  START_TRIAL: "START_TRIAL",
  CREATE_ACCOUNT: "CREATE_ACCOUNT",
}

export const SCOPES = {
  ADMIN: "admin",
  ADMIN_CONTENT: "admin.content",
  ADMIN_INSTAPRO: "admin.instapro",
  USER: "user",
}

export const SCOPE_DATA = {
  [SCOPES.ADMIN]: {
    "label": "Admin - Full",
    "description": "Perform any administrative operations",
  },
  [SCOPES.ADMIN_CONTENT]: {
    "label": "Admin - Content",
    "description": "Perform administrative operations for content",
  },
  [SCOPES.ADMIN_INSTAPRO]: {
    "label": "Admin - Coaching",
    "description": "Perform administrative operations for coaching",
  },
  [SCOPES.USER]: {
    "label": "User - Full",
    "description": "Perform any user operations and View user info",
  },
}



// WEBPACK FOOTER //
// ./src/constants/auth.js